import "./Dialogs.scss";

import React from "react";

import { Dialog, DialogAlignment } from "@itwin/core-react";
import { Button } from "@itwin/itwinui-react";
import { ModalDialogManager, ModelessDialogManager } from "@itwin/appui-react";
import { IconButton } from "@itwin/itwinui-react";

export class cDialog {
  public static confirm(message: string, onOk: any, onCancel: any) {
    ModelessDialogManager.openDialog(
      <Dialog
        id={"confirmDialog"}
        opened={true}
        modal={true}
        onClose={onCancel}
        onEscape={onCancel}
        resizable={false}
        movable={true}
        title={<b>Confirm</b>}
        width={400}
        height={170}
        alignment={DialogAlignment.Center}
      >
        <div>
          <br />
          <span style={{ fontSize: "medium" }}>{message}</span>
          <br />
          <br />
          <div className="confirm-footer">
            <Button styleType="cta" onClick={onOk}>
              OK
            </Button>
            <Button styleType="cta" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </Dialog>,
      "confirmDialog"
    );
  }

  public static closeConfirm() {
    ModelessDialogManager.closeDialog("confirmDialog");
  }
}
